import { useTranslation } from 'react-i18next'

import { Twitter, Facebook } from 'lucide-react'

interface FooterProps {
    onAboutClick?: () => void
    onHelpClick?: () => void
    showAboutLink?: boolean
}

export function Footer({ onAboutClick, onHelpClick, showAboutLink = true }: FooterProps) {
    const { t } = useTranslation()
    const shareUrl = 'https://blazegrids.netherfire.com'
    const shareText = "Check out Blaze Grids! Daily crossword puzzles."

    const twitterUrl = `https://x.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`
    const redditUrl = `https://www.reddit.com/submit?url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(shareText)}`

    return (
        <footer className="mt-auto pt-12 pb-6 text-center text-gray-600 text-sm w-full">
            <div className="flex justify-center gap-6 mb-4">
                <a
                    href={twitterUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-500 hover:text-gray-300 transition-colors"
                    aria-label="Share on X"
                >
                    <Twitter size={20} />
                </a>
                <a
                    href={facebookUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-500 hover:text-gray-300 transition-colors"
                    aria-label="Share on Facebook"
                >
                    <Facebook size={20} />
                </a>
                <a
                    href={redditUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-500 hover:text-gray-300 transition-colors font-bold"
                    aria-label="Share on Reddit"
                >
                    R
                </a>
            </div>

            <p>{t('home.footer')}</p>
            <div className="mt-2 flex justify-center gap-4 text-xs">
                {showAboutLink && (
                    <button
                        onClick={onAboutClick}
                        className="hover:text-gray-400 transition-colors"
                    >
                        {t('home.about')}
                    </button>
                )}
                {onHelpClick ? (
                    <button
                        onClick={onHelpClick}
                        className="hover:text-gray-400 transition-colors"
                    >
                        {t('help.title')}
                    </button>
                ) : (
                    <a href="/help" className="hover:text-gray-400 transition-colors">{t('help.title')}</a>
                )}
                <a href="https://github.com/netherfire/blazegrids" target="_blank" rel="noopener noreferrer" className="hover:text-gray-400 transition-colors">GitHub</a>
            </div>
        </footer>
    )
}
